<template lang="pug">
  .auth--home
    .auth__logos
      img.auth__logo(:alt="appName" :src="logoPath")

      .auth__apps
        a.auth__apps__item(v-if="appleStorePath" :href="appleStorePath")
          img(alt="Apple Store Download App" src="@/assets/appleStore.png")
        a.auth__apps__item(v-if="androidStorePath" :href="androidStorePath")
          img(alt="Google Store Download App" src="@/assets/androidStore.png")

    .auth__device
      .auth__device__screen
        img(src="@/assets/demo-screen.jpg" alt="")

</template>

<script>
import { PROYECT } from "@/constant";

export default {
  data() {
    return {
      appName: PROYECT.NAME,
      logoPath: `/${PROYECT.LOGO}.svg`,
      appleStorePath: PROYECT.STORE.APPLE,
      androidStorePath: PROYECT.STORE.ANDROID
    };
  },
  methods: {
    getMobileOperatingSystem() {
      const userAgent = navigator.userAgent || navigator.vendor;

      if (/android/i.test(userAgent)) {
        return "Android";
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }

      return "unknown";
    },

    detectAndServe() {
      const mobileOperatingSystem = this.getMobileOperatingSystem();

      if (mobileOperatingSystem === "iOS" && this.appleStorePath) {
        window.location.href = this.appleStorePath;
      }
      if (mobileOperatingSystem === "Android" && this.androidStorePath) {
        window.location.href = this.androidStorePath;
      }
    }
  },
  created() {
    this.detectAndServe();
  }
};
</script>
